import { createSelector } from '@reduxjs/toolkit';
import { selectQCTaskSeriesState } from './QCTaskSeries.slice';
import { selectClinicalTrialContextState } from '../clinicalTrialContext/clinicalTrialContext.slice';
import { findVisitConfigById } from '../../pages/QC/helpers/findVisitConfigById';

export const selectQCTaskSeriesWithVisitInfo = createSelector(
  [selectQCTaskSeriesState, selectClinicalTrialContextState],
  (seriesState, contextState) => {
    return (seriesState.data || []).map(visit => {
      const visitInfo = findVisitConfigById(
        contextState.data,
        visit.visitDefinitionId
      );
      return { ...visit, visitInfo };
    });
  }
);
